//@flow
import React from 'react';
import Link from '../../../components/Link';

export default function AdaptogensDropdown() {
  return (
    <div tabIndex="0" role="tabpanel" className="nb-dropdown">
      <div className="nb-dropdown-label-container">
        <Link to="/adaptogens" className="nb-dropdown-label-link">
          <div className="nb-dropdown-label">
            Adaptogens
          </div>
          <div className="nb-dropdown-icon">
          </div>
        </Link>
      </div>
      <ul aria-hidden="false" aria-label="submenu" className="nb-dropdown-items">
        <li role="menuitem">
          <Link to="/maca">Maca</Link>
        </li>
        <li role="menuitem">
          <Link to="/matcha">Matcha</Link>
        </li>
        <li role="menuitem">
          <Link to="/moringa">Moringa</Link>
        </li>
        <li role="menuitem">
          <Link to="/turmeric">Turmeric</Link>
        </li>
        <li role="menuitem">
          <Link to="/ashwagandha">Ashwagandha</Link>
        </li>
      </ul>
    </div>
  );
}
